import React from "react";
import { LayoutMain } from "@unisearch/theme/layout";
import { DailyIdiomsPhrases } from "@modules/elearning/lead";

const DailyUsageIdiomsAndPhrases = () => {
  return (
    <LayoutMain
      title="Speaking Masterclass - Daily Usage Idioms and Phrases"
      footer_with_evaluation
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/elearning/daily-usage-idioms-and-phrases`}
    >
      <DailyIdiomsPhrases />
    </LayoutMain>
  );
};

export default DailyUsageIdiomsAndPhrases;
